import {
  APPROVED_ORDER_STATUS,
  COMPLETED_ORDER_STATUS,
  IN_PROGRESS_ORDER_STATUS,
  ORDER_STATUS,
  PENDING_ORDER_STATUS,
} from "../../../helpers/const";

export default function ProgressBar({ className, header, status, width }) {
  return (
    <div className={className}>
      <p className="text-sm font-medium text-gray-900">
        {ORDER_STATUS.find((stat) => stat.id === status)?.progressText}
      </p>
      <div aria-hidden="true" className="mt-6">
        <div className="overflow-hidden rounded-full bg-gray-200">
          <div
            style={{
              width:
                status >= COMPLETED_ORDER_STATUS.id
                  ? "100%"
                  : `${100 / (4 - status)}%`,
            }}
            className="h-2 rounded-full bg-[var(--primary-color)]"
          />
        </div>
        <div className="mt-6 hidden grid-cols-4 text-sm font-medium text-gray-600 sm:grid">
          <div
            className={
              "" +
              (status >= PENDING_ORDER_STATUS.id
                ? "text-[var(--primary-color)]"
                : "")
            }
          >
            Pending
          </div>
          <div
            className={
              "text-center " +
              (status >= APPROVED_ORDER_STATUS.id
                ? "text-[var(--primary-color)]"
                : "")
            }
          >
            Approved
          </div>
          <div
            className={
              "text-center " +
              (status >= IN_PROGRESS_ORDER_STATUS.id
                ? "text-[var(--primary-color)]"
                : "")
            }
          >
            In Progress
          </div>
          <div
            className={
              "text-right " +
              (status >= COMPLETED_ORDER_STATUS.id
                ? "text-[var(--primary-color)]"
                : "")
            }
          >
            Completed
          </div>
        </div>
      </div>
    </div>
  );
}
